function updateVariant(container){
  var variantId = null;
  var addon_id = null;
  var selectedOptions = [];
  var options = $(this).find('select').val();
  $(container).find('input:not(".mrk-shade-item"):checked').each(function () {
      selectedOptions.push($(this).val());
      $(this).parents('.variant-picker__option').find('.mrk-selected-value').html($(this).val())
  });
  // Fetch variants from the JSON script tag within the quantity-breaks element
  var variants = window.mrkVariants;
  variants.forEach(function (variant) {
      var options = variant.options;
      if (JSON.stringify(options) === JSON.stringify(selectedOptions)) {
          var featured_image = variant.featured_image.src || variant.featured_image,
          featured_image = featured_image + '&width=100'
          addon_image = variant.straight_extension?.featured_image.src || variant.straight_extension?.featured_image;
          addon_image = addon_image  + '&width=100';
          console.log(variant);
          addon_id = variant.straight_extension?.id;
          $('.mrk-main-image').attr('src', featured_image);
          $('.mrk-addon-image').attr('src', addon_image);
          $('[data-swatches-label] span').html(variant.options[0])
      }
  });

  if(addon_id != null)
    $('.mrk-addon').html(`<input name="items[1][id]" type="hidden" value="${addon_id}" />`);
  else
    $('.mrk-addon').html('');
}
$('mrk-variant-picker').on('change', function(){
  updateVariant($(this))
});
$(document).on('change', '.mrk-shade-item', function () {
    const selectedShade = $(this).val();

    if (selectedShade === 'Toutes') {
        $('.mrk-color-item').show();
    } else {
        $('.mrk-color-item').hide().filter(function () {
            const shades = $(this).attr('shades') || '';
            const shadeArray = shades.split(',').map(s => s.trim());
            return shadeArray.includes(selectedShade);
        }).show();
    }
});
$('mrk-variant-picker').trigger('change');
setTimeout(function(){
  $('.product-gallery__thumbnail:eq(0)').click()
},1);
$(document).on('click', '.mrk-swatches-wrapper button', function () {
    var $wrapper = $(this).closest('.mrk-swatches-wrapper');

    if ($(this).attr('aria-label') === 'next') {
        $wrapper.animate({ scrollLeft: $wrapper.scrollLeft() + 100 }, 300);
    } else {
        $wrapper.animate({ scrollLeft: $wrapper.scrollLeft() - 100 }, 300);
    }
});